import React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

/**
 * PageLayout component that provides consistent spacing for pages with navbar
 * Automatically adds the correct top margin to compensate for fixed navbar
 */
const PageLayout = ({ children, maxWidth = 'lg', containerProps = {}, withSidebar = false }) => {
  return (
    <Box
      sx={{
        marginTop: '64px', // Account for fixed navbar
        marginLeft: withSidebar ? '280px' : 0, // Account for sidebar if present
        height: withSidebar ? 'calc(100vh - 64px)' : 'auto', // Fixed height for sidebar, auto for regular pages
        minHeight: withSidebar ? 'auto' : 'calc(100vh - 64px)', // Only set minHeight for regular pages
        overflow: withSidebar ? 'auto' : 'visible', // Enable scroll for sidebar layout
        backgroundColor: '#f5f5f5'
      }}
    >
      <Container 
        maxWidth={maxWidth} 
        sx={{ py: 4, ...containerProps.sx }}
        {...containerProps}
      >
        {children}
      </Container>
    </Box>
  );
};

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  containerProps: PropTypes.object,
  withSidebar: PropTypes.bool
};

export default PageLayout; 
